"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statusTypes = void 0;
var _type = require("../_utils/type");
// 标签的类型
var statusTypes = (0, _type.tuple)('warning', 'success', 'error');
exports.statusTypes = statusTypes;